import styled from 'styled-components';
import { mediaBreakpointUp, gray } from '@whitelabel/helpers/style';

const StyledButtonDivider = styled.hr`
  width: 100%;
  margin-top: 0;
  margin-bottom: 1rem;
  color: ${gray(400)};

  ${mediaBreakpointUp('md')`
    margin-bottom: 2rem;
  `}

  ${mediaBreakpointUp('lg')`
    margin-bottom: 3rem;
  `};
`;

export default StyledButtonDivider;
